import { RateCardFormErrors } from '@state';
import { TLaneSettingsSchema } from '@utils';
import { useSetRecoilState } from 'recoil';
import { ZodFormattedError } from 'zod';

export const useClearRCSettingsError = () => {
	const setRcFormErrors = useSetRecoilState(RateCardFormErrors);

	const clearErrorsAtPath = (obj: {[key:string]: any}, path: string): ZodFormattedError<TLaneSettingsSchema> => {
		const keys = path.split('.');
		const [key] = keys;
		if (keys.length === 1) {
			if (obj[key]?._errors) {
				return {
					...obj,
					[key]: {},
				} as ZodFormattedError<TLaneSettingsSchema>;
			}
			return {
				...obj,
				[key]: {}
			} as ZodFormattedError<TLaneSettingsSchema>;
		}

		if (obj[key]) {
			return {
				...obj,
				[key]: clearErrorsAtPath(obj[key], keys.slice(1).join('.')),
			} as ZodFormattedError<TLaneSettingsSchema>;
		}
		return obj as ZodFormattedError<TLaneSettingsSchema>;
	}

	const handleClearRCSettingsKeyError = (key: string): Promise<void> => {
		return new Promise((resolve) => {
			setRcFormErrors((prevErrors) => {
				if (!prevErrors) return prevErrors;

				if (key.includes('.')) {
					const updated = clearErrorsAtPath(prevErrors, key);
					return updated;
				} else {
					return {} as ZodFormattedError<TLaneSettingsSchema>;
				}
			});
			resolve();
		});
	};

	const clearRCSettingsError = async (value: string | string[]) => {
		if (Array.isArray(value)) {
			for (const key of value) {
				await handleClearRCSettingsKeyError(key);
			}
			return;
		}
		await handleClearRCSettingsKeyError(value);

	};

	return clearRCSettingsError;
};
